import expose from './expose';
import Example from './cb-example';

export const components = [Example];

window.cbWebComponents = window.cbWebComponents || {};
expose(components);
if (window.onWebComponentsLoaded) window.onWebComponentsLoaded();

const obj = {};
export default obj;
